"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_PRIORITIES = exports.DISABLED_EXTENSIONS = exports.DEFAULT_FILE_EXTENTION = void 0;
var DEFAULT_FILE_EXTENTION = 'jpeg';
exports.DEFAULT_FILE_EXTENTION = DEFAULT_FILE_EXTENTION;
var DISABLED_EXTENSIONS = ['svg'];
exports.DISABLED_EXTENSIONS = DISABLED_EXTENSIONS;
var FETCH_PRIORITIES = {
  high: 'high',
  auto: 'auto'
};
exports.FETCH_PRIORITIES = FETCH_PRIORITIES;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJERUZBVUxUX0ZJTEVfRVhURU5USU9OIiwiRElTQUJMRURfRVhURU5TSU9OUyIsIkZFVENIX1BSSU9SSVRJRVMiLCJoaWdoIiwiYXV0byJdLCJzb3VyY2VzIjpbIi4uL3NyYy9jb25zdGFudHMuanMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IERFRkFVTFRfRklMRV9FWFRFTlRJT04gPSAnanBlZyc7XG5leHBvcnQgY29uc3QgRElTQUJMRURfRVhURU5TSU9OUyA9IFsnc3ZnJ107XG5leHBvcnQgY29uc3QgRkVUQ0hfUFJJT1JJVElFUyA9IHtcbiAgaGlnaDogJ2hpZ2gnLFxuICBhdXRvOiAnYXV0bydcbn07XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBTyxJQUFNQSxzQkFBc0IsR0FBRyxNQUFNO0FBQUM7QUFDdEMsSUFBTUMsbUJBQW1CLEdBQUcsQ0FBQyxLQUFLLENBQUM7QUFBQztBQUNwQyxJQUFNQyxnQkFBZ0IsR0FBRztFQUM5QkMsSUFBSSxFQUFFLE1BQU07RUFDWkMsSUFBSSxFQUFFO0FBQ1IsQ0FBQztBQUFDIn0=